
import { Component, mixins } from 'nuxt-property-decorator'
import { OfferStats, StatsResponse } from './types'
import PrefixMixin from '~/utils/mixins/prefixMixin'
import { countOf } from '~/utils/countOf'
import statsForBsx from '~/queries/subsquid/bsx/statsForBsx.graphql'

const components = {
  Identity: () => import('@/components/identity/IdentityIndex.vue'),
  CommonTokenMoney: () => import('@/components/shared/CommonTokenMoney.vue'),
}

@Component({ components })
export default class BsxStats extends mixins(PrefixMixin) {
  public statsResponse!: StatsResponse
  protected offerStats: OfferStats[] = []
  protected keysObject: string[] = []

  fetch() {
    this.getOfferStats()
  }

  protected async getOfferStats() {
    const response = await this.$apollo.query<StatsResponse>({
      client: this.urlPrefix,
      query: statsForBsx,
    })
    this.statsResponse = response.data
    this.keysObject = Object.keys(response.data).filter(
      (key) => key !== 'offerStats'
    )
    this.offerStats = this.statsResponse.offerStats
  }
  protected returnTotalCounts(key, statsResponse) {
    if (key === 'activeWallets') {
      return countOf(statsResponse.activeWallets[0])
    } else {
      return countOf(statsResponse[key])
    }
  }
}
